import { useNavigate } from 'react-router-dom';
import { useEffectOnce } from 'react-use';

type RedirectProps = {
  to: string;
};

export const Redirect: React.FC<RedirectProps> = ({ to }) => {
  const navigate = useNavigate();

  useEffectOnce(() => {
    navigate(to);
  });

  return null;
};
